import { auth } from '../firebase/firebase';


export const createUser = (email, password) => {
    return auth.createUserWithEmailAndPassword(email, password);
}

export const loginUser = (email, password) => {
    return auth.signInWithEmailAndPassword(email, password);
}

export const signOut = () => {
    return auth.signOut()
}

// export const authChange = (callback) => {
//     return auth.onAuthStateChanged((user) => {
//         if (user) {
//             callback(user.email)
//           } else {
//             callback(null)
//           }
//     })
// }

export const authChange = (user) => {
    return auth.onAuthStateChanged(user)
}